// vdb-setting-plp.js
// Delegation-based drawer + accordion controller for vdb-setting-plp.liquid
//
// All handlers are bound once to `document`, so they survive AJAX innerHTML
// swaps of the section (no re-binding needed).
//
// The click handler runs in the CAPTURE phase. When it handles an accordion
// header it calls stopPropagation(), which prevents the theme's own accordion
// component (data-components="accordion") from also toggling the same header.
// The theme re-binds that component after Load More (via collection:loaded /
// shopify:section:load), which would otherwise reintroduce a double-toggle and
// make the accordions appear stuck.

(function () {
  if (window.__vdbPlpInit) return; // guard against double-init if loaded twice
  window.__vdbPlpInit = true;

  function getDrawer() {
    return document.getElementById('clairDrawer');
  }

  // ---- Clicks (delegated, CAPTURE phase) ----
  document.addEventListener(
    'click',
    function (e) {
      // Open drawer
      if (e.target.closest('.clair-filter-btn, .clair-all-filters')) {
        var d = getDrawer();
        if (d) d.classList.add('open');
        return;
      }

      // Close via the X button or the Apply button
      if (e.target.closest('.clair-drawer-close, #formFilterButton')) {
        var d = getDrawer();
        if (d) d.classList.remove('open');
        // do NOT return / stop — let Apply's own filter logic keep running
      }

      // Close when the backdrop itself is clicked (not the content inside it)
      if (e.target.id === 'clairDrawer') {
        e.target.classList.remove('open');
        return;
      }

      // Accordion toggle.
      // stopPropagation() here blocks the theme's accordion component (and any
      // other handler) from double-toggling this header after a re-init.
      var header = e.target.closest('.accordion-header.accordion-action-custom');
      if (header) {
        e.stopPropagation();
        var body = header.nextElementSibling;
        var isOpen = header.classList.toggle('open');
        if (body) body.style.display = isOpen ? 'block' : 'none';
      }
    },
    true // capture phase
  );

  // ---- Sort dropdown (delegated) ----
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('clair-sort-select')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    }
  });
})();
